import type { Item } from '../types/item';

export const itemRowKey = (item: Item): string => String(item.id);

export interface ItemTotals {
  count: number;
  qtyOnHand: number;
  stockValue: number;
}

export const computeItemTotals = (rows: Item[]): ItemTotals => {
  let qtyOnHand = 0;
  let stockValue = 0;
  for (const row of rows) {
    const qty = parseFloat(row.qty_on_hand) || 0;
    const cost = parseFloat(row.standard_cost) || 0;
    qtyOnHand += qty;
    stockValue += qty * cost;
  }
  return {
    count: rows.length,
    qtyOnHand,
    stockValue,
  };
};
